import { render, staticRenderFns } from "./SettingDisplay.vue?vue&type=template&id=1f8f10be&"
import script from "./SettingDisplay.vue?vue&type=script&lang=ts&"
export * from "./SettingDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports